import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Chart anatomy`}</h2>
    <img src="https://user-images.githubusercontent.com/7265547/267488208-cf204662-bf3a-45a1-9c8f-1c21aa2a4549.png" alt="A depiction of the anatomy of a chart component" />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Header`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Use to describe the contents of your chart. Keep the header title concise, but descriptive.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Subheader`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Use a sub header to provide additional context. If you choose not to show axis titles on your chart, you must give users context to the data on screen via a short description. ex. Showing new repositories by date`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Legend`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Only show a legend when showing more than 1 data set`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Sometimes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Marks`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Chart marks are how you represent date on a chart. Common types of marks include bar, line, and area.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Sometimes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Axis Titles`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Axis titles help users understand what is being measured in the displayed chart. If your chart doesn’t use titles, you must provide context to users via a description in the sub header.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Sometimes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Axis Labels`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Axis labels show the units of measurement for the chart.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Graph Lines`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Graph lines help users read the chart marks by connecting context to the axis labels. Some chart types only use horizontal lines and others only use vertical lines.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Axis`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The axis borders define the bounds of the chart.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Point`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A point is a visual cue that is highlighted on hover.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes (used for line charts only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Crosshair`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A crosshair is a visual cue shown in line charts, to help users connect the point to the axis label.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes (used for line charts only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Tooltip`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Tooltips are shown on hover to display data at a given point on a chart. Note that there are single tooltips and multi-line tooltips.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Toolbar Menu`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The toolbar menu contains actions for additional chart interactions. For many chart types, users should be able to preview the data in a table and download the data in a CSV format.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes for most simple charts`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Charts we support`}</h2>
    <p>{`You may see a number of different types of charts across GitHub, including the prolific contributions graph. Today, we support the creation of a specific set of charts and data visualizations, including:`}</p>
    <ul>
      <li parentName="ul">{`Bar charts`}</li>
      <li parentName="ul">{`Line charts`}</li>
      <li parentName="ul">{`Area charts`}</li>
      <li parentName="ul">{`Progress bars`}</li>
    </ul>
    <p>{`We don't currently support the creation of new:`}</p>
    <ul>
      <li parentName="ul">{`Donut charts`}</li>
      <li parentName="ul">{`Sparklines`}</li>
    </ul>
    <h2>{`Choosing chart colors`}</h2>
    <p>{`Stacked bar charts and progress bars should have a high contrast divider line between each segment. It helps to visually delineate between chart colors.`}</p>
    <p>{`Chart / visualization marks need to be at a 3:1 ratio with the background.`}</p>
    <h3>{`Our set of color values`}</h3>
    <p>{`When stacking multiple colors for chart marks, draw in order from the following colors.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Primary chart marks `}{`|`}{` 1 - 7 datasets`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Secondary chart marks `}{`|`}{` 8 - 16 datasets`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><img parentName="td" {...{
              "src": "https://swatch-sid.vercel.app?mode=light&token=scale.blue.5",
              "alt": "\"\""
            }}></img>{` `}<inlineCode parentName="td">{`scale.blue.5`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><img parentName="td" {...{
              "src": "https://swatch-sid.vercel.app?mode=light&token=scale.blue.7",
              "alt": "\"\""
            }}></img>{` `}<inlineCode parentName="td">{`scale.blue.7`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><img parentName="td" {...{
              "src": "https://swatch-sid.vercel.app?mode=light&token=scale.green.4",
              "alt": "\"\""
            }}></img>{` `}<inlineCode parentName="td">{`scale.green.4`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><img parentName="td" {...{
              "src": "https://swatch-sid.vercel.app?mode=light&token=scale.green.6",
              "alt": "\"\""
            }}></img>{` `}<inlineCode parentName="td">{`scale.green.6`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><img parentName="td" {...{
              "src": "https://swatch-sid.vercel.app?mode=light&token=scale.orange.4",
              "alt": "\"\""
            }}></img>{` `}<inlineCode parentName="td">{`scale.orange.4`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><img parentName="td" {...{
              "src": "https://swatch-sid.vercel.app?mode=light&token=scale.orange.6",
              "alt": "\"\""
            }}></img>{` `}<inlineCode parentName="td">{`scale.orange.6`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><img parentName="td" {...{
              "src": "https://swatch-sid.vercel.app?mode=light&token=scale.gray.6",
              "alt": "\"\""
            }}></img>{` `}<inlineCode parentName="td">{`scale.gray.6`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><img parentName="td" {...{
              "src": "https://swatch-sid.vercel.app?mode=light&token=scale.gray.7",
              "alt": "\"\""
            }}></img>{` `}<inlineCode parentName="td">{`scale.gray.7`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><img parentName="td" {...{
              "src": "https://swatch-sid.vercel.app?mode=light&token=scale.pink.5",
              "alt": "\"\""
            }}></img>{` `}<inlineCode parentName="td">{`scale.pink.5`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><img parentName="td" {...{
              "src": "https://swatch-sid.vercel.app?mode=light&token=scale.pink.8",
              "alt": "\"\""
            }}></img>{` `}<inlineCode parentName="td">{`scale.pink.8`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><img parentName="td" {...{
              "src": "https://swatch-sid.vercel.app?mode=light&token=scale.yellow.4",
              "alt": "\"\""
            }}></img>{` `}<inlineCode parentName="td">{`scale.yellow.4`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><img parentName="td" {...{
              "src": "https://swatch-sid.vercel.app?mode=light&token=scale.yellow.6",
              "alt": "\"\""
            }}></img>{` `}<inlineCode parentName="td">{`scale.yellow.6`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><img parentName="td" {...{
              "src": "https://swatch-sid.vercel.app?mode=light&token=scale.red.5",
              "alt": "\"\""
            }}></img>{` `}<inlineCode parentName="td">{`scale.red.5`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><img parentName="td" {...{
              "src": "https://swatch-sid.vercel.app?mode=light&token=scale.red.7",
              "alt": "\"\""
            }}></img>{` `}<inlineCode parentName="td">{`scale.red.7`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><img parentName="td" {...{
              "src": "https://swatch-sid.vercel.app?mode=light&token=scale.purple.5",
              "alt": "\"\""
            }}></img>{` `}<inlineCode parentName="td">{`scale.purple.5`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><img parentName="td" {...{
              "src": "https://swatch-sid.vercel.app?mode=light&token=scale.purple.7",
              "alt": "\"\""
            }}></img>{` `}<inlineCode parentName="td">{`scale.purple.7`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Note:`}</strong>{` There aren’t clear rules on contrast between chart mark colors. We try our best to have reasonable contrast between elements so that they are distinguishable, because specific colors look similar for some types of colorblindness. (e.g. blue and purple look visually similar to some colorblind users). Again, this is where the high contrast divider line becomes helpful for bar charts and progress bars.`}</p>
    <p>{`Sometimes there’s also meaning that is being conveyed with color that represents a state (error, success, critical), so in those cases, it can make sense to change the colors based on the semantic intent.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      